module.exports = __webpack_public_path__ + "img/9791160511864.7c3c351a.jpg";